export default "__VITE_ASSET__D61nHAUo__"